// import { permissionManager } from "../PermissionManager/PermissionManager";

export const HAND_TOOL = 'hand-tool';

export const SELECT_TOOL_TEXT_IMAGE = 'select-text-image';
export const SELECT_TOOL_ANNOTATION = 'select-annotation';
// export const VIEW_SIZE = 'dropdown-zoom';
export const DROPDOWN_ZOOM_IN = 'dropdown-zoom-in';
export const DROPDOWN_ZOOM_OUT = 'dropdown-zoom-out';
export const DROPDOWN_ZOOM_FITPAGE = 'dropdown-zoom-fitpage';
export const DROPDOWN_ZOOM_FITWIDTH = 'dropdown-zoom-fitwidth';
export const DROPDOWN_ZOOM_FITWISIBLE = 'dropdown-zoom-fitvisible';
export const NEW_GUIDES = 'New guides';
export const ADVANCED_SEARCH = 'Advanced search'
export const BASE_SEARCH = 'Start search';

export const FLOAT_PAGE_NUMBER = 'float-page-number'
export const COMMON_ALL_LIST = [
    HAND_TOOL,
    SELECT_TOOL_TEXT_IMAGE,
    SELECT_TOOL_ANNOTATION,
    DROPDOWN_ZOOM_IN,
    DROPDOWN_ZOOM_OUT,
    DROPDOWN_ZOOM_FITPAGE,
    DROPDOWN_ZOOM_FITWIDTH,
    DROPDOWN_ZOOM_FITWISIBLE,

]

// permissionManager.registerPremiumFeatures([
//     'loupe-button',
//     'marquee-button'
// ])